import { createIntl, createIntlCache } from 'react-intl';

const cache = createIntlCache();

let checkoutIntl;

export function getSelfServeIntl() {
  if (checkoutIntl) {
    return checkoutIntl;
  }

  checkoutIntl = createIntl(
    {
      locale: document.documentElement.getAttribute('lang') || 'en',
      messages: window.__GDN_MESSAGES__ || {}
    },
    cache
  );

  return checkoutIntl;
}
